module.exports = __webpack_public_path__ + "static/img/t27.da696822.png";